import { render } from "./feedbackSlider.vue?vue&type=template&id=3f15962c"
import script from "./feedbackSlider.vue?vue&type=script&lang=js"
export * from "./feedbackSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__